@use "../../../../sedestral/sass/mixins/positioning";
@use "../../../../sedestral/sass/mixins/texts";
@use "../../../../sedestral/sass/extends/buttons";
@use "../../../../sedestral/sass/icons/icons";

.globalEmptyBasic {
  height: 100%;
  width: 100%;
  @include positioning.flex-globally;

  .emptyContent {
    position: relative;
    width: 100%;

    .loader {
      position: relative;
      margin-top: 50px;
      height: 50px;
    }

    .emoji {
      font-size: 50px;
      margin-bottom: 15px;
      text-align: center;

      @include positioning.flex-globally;
    }

    .text {
      width: 70%;
      left: 15%;
      margin-bottom: 20px;
      font-size: 16px;
      text-align: center;
      position: relative;
      color: var(--black);

      @include texts.font("semi-bold");
    }

    .buttonContainer {
      width: 100%;
      position: relative;

      @include positioning.flex-globally;

      .button {
        @include buttons.grey;
        @include texts.font("semi-bold");

        padding: 10px 30px;
        width: fit-content;
        background: var(--grey-sur);
        border-radius: 30px;
        font-size: 16px;
        margin-top: 25px;
        position: relative;

        &.black {
          background: var(--black) !important;
          color: var(--white) !important;
          display: flex;
          gap: 5px;
          align-items: center;
          padding: 14px 26px;

          &:hover {
            opacity: 0.8;
          }

          .icon {
            height: 14px;
            width: 14px;
            filter: var(--icon-white);
            transform: rotate(-45deg);

            @include icons.ico("black-right-arrow");
          }
        }

        &.loading {
          display: flex;
          align-items: center;
          justify-content: center;
          color: transparent !important;
        }

        svg {
          height: 60%;

          circle {
            stroke-width: 5px;
          }
        }

        span {
          background: var(--red);
          color: var(--white);
          font-size: 14px;
          padding: 1px 6px;
          border-radius: 15px;
        }
      }
    }
  }
}